var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungeShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3E8BFF",
    strokeWidth: 3,
    d: "M18 6.5c1.243 0 2.368.504 3.182 1.318.814.814 1.318 1.94 1.318 3.182h0v4.5h-9V11c0-1.243.504-2.368 1.318-3.182C15.632 7.004 16.758 6.5 18 6.5z",
    transform: "translate(-2387 -622) translate(2387 622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F73F3",
    d: "M8.79 13h18.42c1.019 0 1.875.766 1.988 1.78l1.555 14c.122 1.097-.669 2.086-1.767 2.208-.073.008-.147.012-.22.012H7.234c-1.105 0-2-.895-2-2 0-.074.004-.148.012-.22l1.555-14C6.915 13.765 7.771 13 8.79 13z",
    transform: "translate(-2387 -622) translate(2387 622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14 17h8c.552 0 1 .448 1 1s-.448 1-1 1h-8c-.552 0-1-.448-1-1s.448-1 1-1z",
    transform: "translate(-2387 -622) translate(2387 622)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeShop);
export default __webpack_public_path__ + "static/media/lounge-shop.edfc4f85.svg";
export { ForwardRef as ReactComponent };